import { render } from "./Customer.vue?vue&type=template&id=0b212e4c&scoped=true&ts=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=0b212e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b212e4c"]])

export default __exports__